import styled from 'styled-components'
import {deviceMax} from '../../theme/breakpoints'
import pxToRem from '../../utils/pxToRem'
import Button from '../Button/Button'
import Heading from '../Heading/Heading'

export const StyledEvent = styled.div`
  display: flex;
  width: 100%;
  padding: ${pxToRem(10)};
  max-width: ${pxToRem(549)};
  background: ${({theme}) => theme.colors.secondary.whitesmoke};
  border-radius: ${pxToRem(10)};
`

export const BlockDate = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  max-width: ${pxToRem(120)};
  height: 100%;
  max-height: ${pxToRem(120)};
  margin-right: ${pxToRem(10)};
  border-radius: ${pxToRem(5)} ${pxToRem(5)} ${pxToRem(30)} ${pxToRem(5)};
  background: ${({theme}) => theme.colors.unique.black};
  @media ${deviceMax.mobileL} {
    max-width: ${pxToRem(60)};
    height: auto;
    max-height: none;
    border-radius: ${pxToRem(5)} ${pxToRem(5)} ${pxToRem(15)} ${pxToRem(5)};
  }
`

export const BlockText = styled.div`
  justify-content: space-between;
  flex-direction: column;
  display: flex;
  width: 100%;
`
export const StyledCTAContainer = styled.div`
  justify-content: space-between;
  display: flex;
  width: 100%;
  gap: ${pxToRem(10)};
`

export const StyledButton = styled(Button)`
  @media ${deviceMax.mobileL} {
    width: 100%;
  }
`

export const StyledHeading = styled(Heading)`
  @media ${deviceMax.mobileL} {
    margin-bottom: ${pxToRem(10)};
  }
`

export const StyledDateContainer = styled.div`
  align-items: center;
  justify-content: center;
  flex-direction: column;
  display: flex;
  width: 100%;
  height: 100%;
  padding: ${pxToRem(14.5)} 0;
  @media ${deviceMax.mobileL} {
    padding: 0;
  }
`

export const StyledDay = styled.p`
  font-size: ${({theme}) => theme.fonts.sizes.titleH1.laptop};
  font-weight: ${({theme}) => theme.fonts.weight.bold};
  line-height: ${({theme}) => theme.fonts.lineHeight.titleH1};
  color: ${({theme}) => theme.colors.unique.white};
  @media ${deviceMax.mobileL} {
    font-size: ${({theme}) => theme.fonts.sizes.titleH3.laptop};
    line-height: ${({theme}) => theme.fonts.lineHeight.titleH3};
  }
`
export const StyledMonthYear = styled.p`
  color: ${({theme}) => theme.colors.unique.white};
  font-size: ${({theme}) => theme.fonts.sizes.titleH3.laptop};
  font-weight: ${({theme}) => theme.fonts.weight.bold};
  line-height: ${({theme}) => theme.fonts.lineHeight.titleH3};
  @media ${deviceMax.mobileL} {
    font-size: ${pxToRem(13)};
    line-height: ${pxToRem(15)};
    font-size: ${({theme}) => theme.fonts.sizes.sm};
    line-height: ${({theme}) => theme.fonts.lineHeight.sm};
  }
`

export const MonthYearContainer = styled.div`
  justify-content: center;
  align-items: center;
  flex-direction: column;
  display: flex;
  width: 100%;
`

export const StyledSeparator = styled.div`
  width: ${pxToRem(20)};
  height: ${pxToRem(2)};
  border-radius: ${pxToRem(10)};
  background-color: ${({theme}) => theme.colors.primary.blue};
`

export const UnderLineBlock = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  gap: ${pxToRem(5)};
`
